const styObj = {
  // 局部样式变量示例
  vava: {
    '--button-color': '#a338fc',
  },
  echo: {
    '--button-color': '#ff3b30',
  },
  joychat: {
    '--button-color': '#20d887',
  },
  kiko: {
    '--button-color': '#FFEC00',
  },
  joylink: {
    '--button-color': '#a338fc',
  },
  goparty: {
    '--button-color': '#a338fc',
  }
}

export const pageCssVars = {
  methods: {
    cssVars () {
      if (this.pkgName && styObj[this.pkgName]) {
        return { ...styObj[this.pkgName] }
      }
      return {}
    }
  }
}
